export class Product {
    id: number;
    name: string;
    tag: string;
    highlighted?: boolean;
    hovered?: boolean;
}
